<template>
    <div>
        <!-- Filtros secundarios en grid responsive -->
        <div class="tw:grid tw:grid-cols-1 tw:sm:grid-cols-2 tw:xl:grid-cols-5 tw:gap-3">
            <BaseMultiselect
                id="search"
                name="search_for"
                label="Buscar por"
                :options="[
                    { id: 'n_abonado', label: 'Nº Abonado' },
                    { id: 'dni', label: 'DNI' },
                    { id: 'nombre_apellidos', label: 'Nombre y Apellidos' },
                    { id: 'penista', label: 'Peña / Empresa' },
                    { id: 'email', label: 'Email' },
                    { id: 'telefono', label: 'Teléfono' },
                    { id: 'taquillero', label: 'Taquillero/a' }
                ]"
                value-key="id"
                label-key="label"
                :value="local.search_for"
                :disabled="disabled"
                @input="val => local.search_for = val"
            />

            <BaseMultiselect
                name="tipo_abono"
                label="Tipo de abono"
                :options="tipos_abono"
                value-key="id"
                label-key="descripcion"
                :value="local.tipo_abono"
                :disabled="disabled || tipos_abono.length === 0"
                @input="onTipoAbonoChange"
            />

            <BaseMultiselect
                v-if="tipoAbonoSeleccionado?.descuentos"
                name="tipo_precio"
                label="Tipo de precio"
                :options="tipoAbonoSeleccionado ? tipoAbonoSeleccionado.descuentos : []"
                value-key="id"
                label-key="descripcion"
                :value="local.tipo_precio"
                :disabled="disabled || !tipoAbonoSeleccionado || !(tipoAbonoSeleccionado.descuentos && tipoAbonoSeleccionado.descuentos.length)"
                @input="val => local.tipo_precio = val || null"
            />

            <BaseMultiselect
                name="metodo_pago"
                label="Método de pago"
                :options="metodos_pago"
                value-key="id"
                label-key="nombre"
                :value="local.metodo_pago"
                :disabled="disabled || metodos_pago.length === 0"
                @input="val => local.metodo_pago = val"
            />

            <BaseMultiselect
                name="tipo"
                label="Tipo de abonado"
                :options="[
                    { id: '0', label: 'Normal' },
                    { id: '1', label: 'Simpatizante', visible: configuracion?.simpatizante }
                ].filter(opt => opt.visible !== false)"
                value-key="id"
                label-key="label"
                :value="local.tipo"
                :disabled="disabled"
                @input="val => local.tipo = val"
            />

            <BaseMultiselect
                name="activos"
                label="Estado"
                :options="[
                    { id: '1', label: 'Activos' },
                    { id: '0', label: 'Inactivos' }
                ]"
                value-key="id"
                label-key="label"
                :value="local.activos"
                :disabled="disabled"
                @input="val => local.activos = val"
            />
        </div>

        <div class="tw:flex tw:items-center tw:justify-end tw:w-full tw:mt-4">
            <Button
                :disabled="disabled"
                customClass="tw:w-full tw:md:w-auto"
                @click="resetFilters"
            >
                Limpiar filtros
            </Button>
        </div>
    </div>
</template>

<script setup>
    import { reactive, watch, computed } from 'vue'
    import BaseMultiselect from '@/modules/admin/ui/BaseMultiselect.vue'
    import Button from '@/modules/admin/ui/Button.vue'

    const props = defineProps({
        filters: {
            type: Object,
            required: true
        },
        tipos_abono: {
            type: Array,
            default: () => []
        },
        metodos_pago: {
            type: Array,
            default: () => []
        },
        configuracion: {
            type: Object,
            default: () => ({})
        },
        disabled: {
            type: Boolean,
            default: false
        }
    })

    const emit = defineEmits(['reset', 'update:filters'])
    const local = reactive({ ...props.filters })
    const tipoAbonoSeleccionado = computed(() =>
        props.tipos_abono.find(t => t.id === local.tipo_abono) || null
    )

    watch(
        () => props.filters,
        newVal => {
            if (!newVal) return
            Object.assign(local, newVal)
        },
        { deep: true }
    )

    watch(
        local,
        val => {
            emit('update:filters', { ...val })
        },
        { deep: true }
    )

    watch(tipoAbonoSeleccionado, val => {
        if (!val || !(val.descuentos && val.descuentos.length)) {
            local.tipo_precio = null
        }
    })

    function onTipoAbonoChange(val) {
        local.tipo_abono = val || null
        local.tipo_precio = null
    }

    function resetFilters() {
        emit('reset')
    }
</script>
